import { useQuery } from '@apollo/client';
import {
  Dropdown,
  IDropdownOption,
  Stack,
  Text,
  TooltipHost,
} from '@fluentui/react';
import { useCommonStyles } from 'common/styles';
import React from 'react';
import { ActiveApprovalPhases } from '../__generated__/ActiveApprovalPhases';
import ACTIVE_APPROVAL_PHASE from '../ActiveApprovalPhases.graphql';

export interface ProjectPhaseOptionProp extends IDropdownOption {
  _activeCount: number | null;
}

type ProjectPhaseProps = {
  onChange: (value: string | undefined) => void;
  projectPhase: string | undefined;
};

export const ProjectPhase: React.FC<ProjectPhaseProps> = (props) => {
  const { data: approvalPhaseData } = useQuery<ActiveApprovalPhases>(
    ACTIVE_APPROVAL_PHASE
  );

  const projectPhaseOptions: ProjectPhaseOptionProp[] = [
    { key: -1, text: 'All', _activeCount: 0 },
    ...(approvalPhaseData?.activeApprovalPhases?.nodes?.map(
      (item): ProjectPhaseOptionProp => ({
        key: item.id,
        text: item.phaseName ?? '',
        _activeCount: item._activeCount,
      })
    ) || []),
  ];

  const commonStyles = useCommonStyles();
  return (
    <Stack verticalAlign="center" tokens={{ childrenGap: 10 }} horizontal>
      <Text variant="xLarge" className={commonStyles.colorThemePrimary}>
        Project phase
      </Text>
      <TooltipHost content={'Project phase'}>
        <Dropdown
          selectedKey={Number(props.projectPhase)}
          options={projectPhaseOptions}
          styles={{
            dropdown: {
              width: 'fit-content',
              minWidth: 120
            }
          }}
          calloutProps={{
            styles: {
              root: {
                width: 'fit-content',
                minWidth: 120
              }
            }
          }}
          onChange={(_, option) => {
            props.onChange(option?.key.toString());
          }}
        />
      </TooltipHost>
    </Stack>
  );
};
